export enum ETipoItem {
    Produto = 1,
    Servico = 2
}
